<template>
  <div class="data-list">
    <div class="head-box">
      <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="新商户流水对账" name="2"></el-tab-pane>
        <el-tab-pane label="老商户流水对账" name="1"></el-tab-pane>
      </el-tabs>
      <search-box class="search-box">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="120px" size="mini">
          <el-form-item label="查询时间" prop="updatedTime">
            <q-date-picker v-model="searchForm" ref="dateRef" />
          </el-form-item>
          <el-form-item label="业务凭证号" prop="orderNo">
            <el-input class="form-input" v-model="searchForm.orderNo" clearable placeholder="请输入业务凭证号"></el-input>
          </el-form-item>
          <el-form-item label="收支类型" prop="transferType">
            <el-select v-model="searchForm.transferType" placeholder="请选择" clearable @change="onSearch">
              <el-option label="全部" value=""> </el-option>
              <el-option label="收入" value="1"> </el-option>
              <el-option label="支出" value="2"> </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="对账结果" prop="name" label-width="120px">
            <el-select v-model="searchForm.name"  size="small" placeholder="请选择">
              <el-option label="全部" value=""> </el-option>
            </el-select>
          </el-form-item> -->
        </el-form>
        <template v-slot:right>
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
    </div>
    <content-panel>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="iportVisible = true">账单导入</el-button>
          <el-button type="primary" size="small" @click="oneClickReconciliation">一键对账</el-button>
          <el-button type="primary" size="small" @click="jumpRecord">对账记录</el-button>
          <el-button type="primary" size="small" @click="handleAdd(null, 1)">导出</el-button>
        </template>
        <el-table stripe v-loading="loading" ref="tableRef" highlight-current-row :data="tableData" border :height="maxTableHeight">
          <el-table-column prop="id" label="序号" align="center" width="80">
          </el-table-column>
          <el-table-column prop="tradingTime" label="交易时间" width="160" show-overflow-tooltip></el-table-column>
          <el-table-column prop="transferType" label="收支类型" width="100" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ transferTypeText[scope.row.transferType] || "" }}
            </template>
          </el-table-column>
          <el-table-column prop="descr" label="业务说明" align="center"></el-table-column>
          <el-table-column prop="amount" label="交易金额" align="center" width="100"></el-table-column>
          <el-table-column prop="handlingFee" label="手续费" align="center" width="90"></el-table-column>
          <el-table-column prop="rate" label="手续费费率" align="center" width="120"></el-table-column>
          <el-table-column prop="orderNo" label="业务凭证号" align="center" width="200" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column prop="joinNum" label="导入时间" align="center" width="160"></el-table-column> -->
          <el-table-column prop="updatedTime" label="对账时间" align="center" width="160"></el-table-column>
          <el-table-column prop="status" label="对账结果" align="center" width="160">
            <template slot-scope="{ row }">
              <span :style="`${row.statusString == '异常' ? 'color: red' : ''}`">{{ row.statusString }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180" fixed="right">
            <template v-slot="scope">
              <el-button type="text" size="small" style="color: red" @click="Reconciliation(scope.row, 1)" v-if="scope.row.status == 0"> 无需处理 </el-button>
              <el-button type="text" size="small" @click="Reconciliation(scope.row, 2)" v-if="scope.row.status == 0"> 重新对账 </el-button>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
      <import-dialog :visible.sync="iportVisible" v-if="iportVisible" :activeName="activeName" @success="init"></import-dialog>
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import importDialog from "./import.vue";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: "account",
  mixins: [tableMixin,pagePathMixin],
  components: { importDialog },
  data() {
    return {
      searchForm: {
        orderNo: "",
        transferType: "",
        startTime: "",
        endTime: "",
      },
      panelData: {},

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      searchFormData: {},
      loading: false,
      resizeOffset: 70,
      actionType: 1,
      isShowAdd: false,
      modifyData: null,
      activeName: "2",
      iportVisible: false,
      statusText: {
        0: "异常",
        1: "异常后恢复为正常",
        2: "无需处理",
      },
      transferTypeText: {
        1: "收入",
        2: "支出",
      },
    };
  },
  methods: {
    handleClick() {
      this.init();
    },
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
          type: this.activeName
        },
      };
      this.searchFormData = params.filterData
      this.$api.dataReport
        .diffPageList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.initDate()
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    async oneClickReconciliation() {
      let status = await this.$confirm(`是否确认一键对账？`, "提示", { type: "warning" });
      if (status !== "confirm") return;
      let { startTime, endTime } = this.filterParam;
      let data = {
        startTime,
        endTime,
        type: this.activeName
      }
      this.$api.dataReport.reconciliation(data).then((res) => {
        if (res.success) {
          this.$message.success(`一键对账成功`);
        } else {
          this.$message.error(`一键对账失败`);
        }
        this.onSearch();
      });
    },
    async Reconciliation(row, type) {
      let text = type === 1 ? "无需处理" : "重新对账";
      let status = await this.$confirm(`是否确认${text}？`, "提示", { type: "warning" });
      if (status !== "confirm") return;
      let interfaceType = type === 1 ? this.$api.dataReport.setDiff : this.$api.dataReport.againReconciliation;
      interfaceType(row.id).then((res) => {
        if (res.success) {
          this.$message.success(`${text}成功`);
        } else {
          this.$message.error(`${text}失败`);
        }
        this.onSearch();
      });
    },
    handleAdd() {
      let params = {
        ...this.searchFormData,
      };
      this.$api.common.doExport("diffPageList", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
    initDate() {
      this.searchForm.startTime = ''
      this.searchForm.endTime = ''
      this.$refs.dateRef.reset()
    },
    jumpRecord() {
      this.openSubPage({
        path: "/dataReport/record",
        query: this.searchFormData
      });
    },
  },
  filters: {},
  mounted() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.data-list {
  // margin: 0 10px;
  // background: #fff;
  .head-box {
    margin: 0 15px;
    margin-top: 5px;
    padding: 10px;
    border-radius: 5px;
    background: #fff;
  }
  .date-input  {
    width 220px !important
  }
  .data-list-header {
    margin: 6px 16px;
    .header {
      color: #ccc;
      text-align: center;
      padding: 6px 0;
      border-bottom: 1px solid #ccc;
    }
    .number {
        text-align: center;
        padding: 6px 0;
    }
  }
}
>>> .el-button--text {
  padding: 0
}
</style>
